import { postApi } from './api_instance'

export const subscribe = async ({ email }, dispatch) => {
  try {
    const  response  = await postApi({
      apiUrl: '/api/subscription',
      dispatch,
      data: { email }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
